import React, { useMemo } from 'react';
import { css, cx } from 'linaria';
import t from '@jetshop/intl';
import Button, { buttonTertiary } from '../../../ui/Button';
import { theme } from '../../../Theme';

const filterButtonCSS = css`
  width: 100%;
  justify-content: center;
  &__counter {
    font-weight: 400;
    margin-left: ${theme.space[1]};
  }

  ${theme.above.md} {
    max-width: 213px;
  }
`;

const base = filterButtonCSS;

const FilterButton = ({ showTarget, filters }) => {
  const numOfActiveFilters = useMemo(() => {
    let activeFilters = 0;
    filters.forEach(filter => {
      switch (filter.__typename) {
        case 'ListFilter':
        case 'MultiListFilter':
          if (filter.hasActiveItems)
            activeFilters += filter.items.filter(item => item.isActive).length;
          break;
        case 'NumericRangeFilter':
          if (filter.isActive) activeFilters++;
          break;
        case 'BooleanFilter':
          if (filter.value) activeFilters++;
          break;
        default:
          break;
      }
    });

    return activeFilters;
  }, [filters]);

  return (
    <>
      <Button className={cx(base, buttonTertiary)} onClick={showTarget}>
        {t('Filter & sort')}
        <span className={`${base}__counter`}>
          {numOfActiveFilters > 0 && ` (${numOfActiveFilters})`}
        </span>
      </Button>
    </>
  );
};

export default FilterButton;
